import React from 'react';
export const AboutBtn = props => {
    return (
        <button
            className='about-btn--close btn-ripple'
            onClick={props.toggleOverlay}
            aria-label='Close About Me'
            tabIndex={props.isOverlay ? "0" : "-1"}
        >
            <div className='ripple'></div>
            <span className='about-bar about-bar--left'></span>
            <span className='about-bar about-bar--right'></span>
        </button>
    );
};
